import { render, staticRenderFns } from "./TtsVoiceSelection.vue?vue&type=template&id=35843152&scoped=true&"
import script from "./TtsVoiceSelection.vue?vue&type=script&lang=ts&"
export * from "./TtsVoiceSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35843152",
  null
  
)

export default component.exports